import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalStatusReportWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.status-report",
  name: "Rental value by status",
  description: "Rental value by status using the reusable report-widget visualization.",
  apps: [
    "rental",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "total_amount",
          as: "value",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "value",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Rental value by status",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "0",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
